import $ from "jquery";
import svg4everybody from "svg4everybody";

$(function () {
  svg4everybody({
    polyfill: true,
  });
});
